import React from 'react';
import { ItemDto } from '@app/models/dtos/strapi';

interface ItemProps {
    item: ItemDto;
    hasStep?: boolean;
    index?: number;
}

function Item({ item, hasStep, index }: ItemProps) {
    return (
        <div>
            {hasStep && <p className="P2 mb-4 !text-blue">Step {index}</p>}
            <p className="h5 mb-2 text-black-1">{item.title}</p>
            <p className="P2 text-black-2">{item.description}</p>
        </div>
    );
}

export default Item;
